<template>
  <v-hover v-slot="{ hover }">
    <v-img :class="colorImage(hover)" contain :src="src" aspect-ratio="1" />
  </v-hover>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ImageOnHoverChangeColor extends Vue {
  @Prop({ default: 800 })
  src!: number;

  hover = false;

  colorImage(hover: boolean) {
    if (!hover) {
      return "greyScale";
    } else {
      return "";
    }
  }

  isHovering = false;
}
</script>
<style scoped>
.greyScale {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
</style>
